<template>

</template>

<script>
export default {
  created() {
    this.$store.commit('authLogout')
    this.$router.push({ name: 'login' })
  }
}
</script>
